import React, {useState} from 'react';
import Array from './array';
import Header from './header';


function Home(props){
    const [search, setAppsearch]=useState('yellow+flowers');
    const [appSort, setAppsort]=useState('none');

    return(
        <div className="w-100">
        <Header searchFor={val => setAppsearch(val)} s={search} appSort={appSort} sortApp={sortVal => setAppsort(sortVal)}/>
        <div className="container-fluid"><Array s={search} appSort={appSort}/></div>
        
    </div> 
    )
}

export default Home